import site, { absoluteUrl } from "../data/site";

const postalAddress = {
  "@type": "PostalAddress",
  addressLocality: site.address.locality,
  addressCountry: site.address.country,
};

export function organizationNode() {
  return {
    "@type": "Organization",
    "@id": `${site.siteUrl}/#organization`,
    name: site.siteName,
    url: absoluteUrl("/"),
    logo: {
      "@type": "ImageObject",
      url: site.logo,
    },
    image: site.ogImage,
    email: site.email,
    telephone: site.phone,
    address: postalAddress,
    areaServed: "Worldwide",
    founder: {
      "@type": "Person",
      name: site.founder,
    },
  };
}

export function homeGraph() {
  return {
    "@context": "https://schema.org",
    "@graph": [
      organizationNode(),
      {
        "@type": "ProfessionalService",
        "@id": `${site.siteUrl}/#business`,
        name: site.siteName,
        url: absoluteUrl("/"),
        image: site.ogImage,
        email: site.email,
        telephone: site.phone,
        priceRange: "$$",
        address: postalAddress,
        areaServed: "Worldwide",
        description: site.home.description,
        founder: {
          "@type": "Person",
          name: site.founder,
        },
        hasOfferCatalog: {
          "@type": "OfferCatalog",
          name: "DigitaliNation services",
          itemListElement: site.services.map((service) => ({
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: service.title,
              url: absoluteUrl(`/services/${service.slug}`),
            },
          })),
        },
      },
      {
        "@type": "WebSite",
        "@id": `${site.siteUrl}/#website`,
        url: absoluteUrl("/"),
        name: site.siteName,
        publisher: { "@id": `${site.siteUrl}/#organization` },
        inLanguage: "en",
      },
    ],
  };
}

export function aboutGraph() {
  return {
    "@context": "https://schema.org",
    "@graph": [
      organizationNode(),
      {
        "@type": "AboutPage",
        "@id": `${absoluteUrl("/about")}#webpage`,
        url: absoluteUrl("/about"),
        name: site.about.title,
        description: site.about.description,
        isPartOf: { "@id": `${site.siteUrl}/#website` },
        about: { "@id": `${site.siteUrl}/#organization` },
        inLanguage: "en",
      },
    ],
  };
}

export function servicesItemList() {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "DigitaliNation services",
    itemListElement: site.services.map((service, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: service.title,
      url: absoluteUrl(`/services/${service.slug}`),
    })),
  };
}

export function serviceSchema(service) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name: service.title,
    serviceType: service.title,
    description: service.seoDescription,
    url: absoluteUrl(`/services/${service.slug}`),
    image: `${site.siteUrl}${service.image}`,
    provider: {
      "@type": "Organization",
      name: site.siteName,
      url: absoluteUrl("/"),
      telephone: site.phone,
      email: site.email,
      address: postalAddress,
    },
    areaServed: "Worldwide",
  };
}
